import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const OverviewAccountSkeleton = () => {
    const divs = Array.from({ length: 5 }, (_, index) => (
        <div className="my-2" key={index}>
            <Skeleton variant="rectangular" width={'92%'} height={50} />
        </div>
    ));

    return (
        <div className="my-4">{divs}</div>
    );
}

export default OverviewAccountSkeleton;